/* eslint-disable no-debugger */
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  isLoading: false,
  isError: false,
  error: '',
  isExclusionError: false,
  errorExclusionMsg: '',
  isSuccess: false,
  success: '',
  successNewRule: '',
  isExclusionSuccess: false,
  status: true,
  exclusionRulesSetData: [],
  particularExclusionRuleData: {},
  newId: null
};

const slice = createSlice({
  name: 'exclusionrules',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    resetExclusionFileError(state) {
      state.error = '';
      state.isError = false;
    },
    resetExclusionRuleSuccess(state) {
      state.success = '';
      state.successNewRule = '';
      state.isExclusionSuccess = false;
      state.isSuccess = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.isLoading = false;
      state.error = message;
      state.isError = true;
    },
    // GET MASTER_FILE
    getExclusionRuleDataSuccess(state, action) {
      state.isLoading = false;
      state.exclusionRulesSetData = action.payload;
    },
    // CREATE MASTER_FILE
    createNewExclusionRuleSuccess(state, action) {
      const newExclusionRuleData = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.success = 'New Rule Added Successfully';
      state.isExclusionSuccess = true;
      state.successNewRule = 'New Rule Added Successfully';
    },
    // DELETE_MASTER_FILE
    deleteExclusionRuleSuccess(state, action) {
      state.isLoading = false;
      state.isSuccess = true;
      state.success = 'Deleted Successfully';
    },
    // UPDATE_MASTER_FILE
    updateExclusionRuleSuccess(state, action) {
      state.isLoading = false;
      state.isSuccess = true;
      state.success = 'Updated Successfully';
    },
    // UPDATE EXCLUSION PARENT RULE NAME
    updateExclusionParentRuleSuccess(state, action) {
      state.isSuccess = true;
      state.success = 'Updated Successfully';
      state.isLoading = false;
      // state.exclusionRulesSetData = updateExclusionRule;
    },
    // get Particular Exclusion Data
    getParticularExclusionRuleSuccess(state, action) {
      state.isLoading = false;
      state.particularExclusionRuleData = { ...state.particularExclusionRuleData, [action.payload.id]: action.payload };
    },
    // add more Rules locally
    addParticularExclusionRuleSuccess(state, action) {
      state.isLoading = false;
      const { fileObj, id, segmentName } = action.payload;
      // Object.keys(state.particularExclusionRuleData).filter(key => state.particularExclusionRuleData[key] === id);
      if (segmentName === state.particularExclusionRuleData[segmentName]) {
        state.particularExclusionRuleData = {
          ...state.particularExclusionRuleData,
          [id]: {
            ...state.particularExclusionRuleData[id],
            rules: [...state.particularExclusionRuleData[id].rules, { ...fileObj, id }]
          }
        };
      } else {
        state.particularExclusionRuleData = {
          ...state.particularExclusionRuleData,
          [id]: { segmentName, campaign_rule_name: 'new rule123', status: 'active', rules: [{ ...fileObj }] }
        };
        state.newId = id;
      }
    },
    // create new Campaign Rule Name
    createExclusionRuleParentSuccess(state, action) {
      state.isSuccess = true;
      state.success = 'Exclusion Rule Set Created Successfully';
      state.isLoading = false;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  resetExclusionFileError,
  resetExclusionRuleSuccess,
  addParticularExclusionRuleSuccess,
  createExclusionRuleParentSuccess
} = slice.actions;

// ----- get Exclusion RuleSet
export function getExclusionRuleData() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: 'http://smartcollect-api.cp360apps.com/exclusionrules/exclusions-rule/'
      });
      dispatch(slice.actions.getExclusionRuleDataSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// ----create Exclusion Rule File
export function createNewExclusionRule(fileObj, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/exclusionrules/rule-column/${id}/`,
        data: fileObj
      });
      dispatch(slice.actions.createNewExclusionRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// --- delete Exclusion Rule File
export function deleteExclusionRule(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/exclusionrules/rule-collection-delete/${id}/`
      });
      dispatch(slice.actions.deleteExclusionRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// Update Exclusion Rule
export function updateExclusionRule(ExclusionRuleData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/exclusionrules/rule-collection-edit/${id}/`,
        data: ExclusionRuleData
      });
      dispatch(slice.actions.updateExclusionRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// Update Exclusion Parent Rule
export function updateExclusionParentRule(ExclusionParentRuleData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/exclusionrules/exclusions-rule/${id}/`,
        data: ExclusionParentRuleData
      });
      dispatch(slice.actions.updateExclusionParentRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// get particular eclusion data
export function getParticularExclusionRule(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/exclusionrules/exclusions-rule/${id}/`
      });
      dispatch(slice.actions.getParticularExclusionRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// add Particular CampaignRule
export function addParticularExclusionRule(fileObj, segmentName, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const segmentFileObj = { fileObj, id, segmentName };
      dispatch(slice.actions.addParticularExclusionRuleSuccess(segmentFileObj));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// create new Exclusion Rule Set Parent
export function createExclusionRuleParent(exclusionNameObj, rules) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/exclusionrules/exclusions-rule/`,
        data: exclusionNameObj
      });
      dispatch(createExclusionRuleParentSuccess());
      dispatch(updateExclusionRuleSet(rules, response.data?.id));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

export function updateExclusionRuleSet(fileObj, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/exclusionrules/exclusions-rule-update/${id}/`,
        data: fileObj
      });
      dispatch(slice.actions.updateExclusionRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}
